import React from 'react';
import Helmet from 'react-helmet';
import { CcusErrorDialog } from '../components/modals/CcusErrorDialog';
import AuthProvider from '../utilities/authProvider';
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import * as _ from 'lodash';
import ClipLoader from 'react-spinners/ClipLoader';
import {
  SafetyDiaryForm,
  SafetyDiaryFormData,
} from '../components/forms/SafetyDiaryForm';
import Confirmation from '../components/modals/common/Confirmation';
import Information from '../components/modals/common/Information';
import { FieldService } from '../services/Fields';
import ExternalServiceCooperationStatusApi from '../services/ExternalServiceCooperationStatusApi';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  FLAG_STAUS,
  HEADER_CONSTANTS,
  DIRECT_STATUS_CODE,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import {
  getSafetyDiaryDetailPageName,
  canSafetyDiaryRemove,
  canSafetyDiaryEdit,
} from '../utilities/roleUtility';
import SafetyDiariesConstants from '../utilities/safetyDiariesConstants';
import _slideLoader from '../utilities/slideLoader';
import { isNullOrEmpty } from '../utilities/stringUtil';
import { ConferencePageHeader } from '../components/PageHeader';
import dialogLoader from '../utilities/dialogLoader';
import Loader from '../components/Loader';
import { ArrowPagingIcon } from '../components/icons/ArrowPagingIcon';
import { localizeMessage } from '../utilities/validateMessage';
import { CloseEditView } from '../components/CloseEditView';
import { FormInformationDialog } from '../components/FormInformationDialog';
import safetyDiariesConstants from '../utilities/safetyDiariesConstants';

// ダイアログ名
const DIALOG_NAME = {
  close: 'close', // クローズ
  withdraw: 'withdraw', // 取り下げ承認
  delete: 'delete', // 削除
  movePage: 'movePage', // 是正内容入力
  withdrawNeedUpdate: 'withdrawNeedUpdate', // 更新してから取り下げ承認
  errorfileType: 'errorfileType', // ファイルタイプエラー
  errorfileSize: 'errorfileSize', // ファイルサイズエラー
  notNotifiedUsers: 'notNotifiedUsers', // 通知対象外ユーザー
  notFound: 'notFound', // 巡回記録が見つからない
};

/**
 * @description 巡回記録新規登録/巡回記録詳細・編集
 */
class SafetyDiariesRegister extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      userId: LocalStorageService.getUserId(), // ユーザーID
      roleId: LocalStorageService.getRoleId(), // ロールID
      formData: SafetyDiaryFormData, // フォームデータ
      // props.view.state.idは巡回記録画面で選択したレコードのIDが入る(slideLoader.js publishView)
      dataId: Number(props.view.state.id) > 0 ? props.view.state.id : null, // 巡回記録ID
      prev: null, // 前の巡回記録
      next: null, // 次の巡回記録
      displayFlg: {
        field_item_list1_display_flag: '', // 作業場所フラグ1
        field_item_list2_display_flag: '', // 作業場所フラグ2
        field_item_list3_display_flag: '', // 作業場所フラグ3
        field_item_list4_display_flag: '', // 作業場所フラグ4
      },
      visibleDialogName: null, // ダイアログ名
      validateMessages: {}, // バリデーションメッセージ
      loaded: false,
      notNotifiedUsers: [],
      hasError: false,
      externalServiceCooperationStatus: {
        line_works: {
          available: false,
        },
        direct: {
          available: false,
          reason_code: null,
        },
      },
      callApiDirectTalkRoomStatus: false,
      directTalkRooms: [],
    };

    this.updatingFlag = false; // 多重更新防止Flag
    this.prevUpdateFormData = null; // 更新必要か比較するために更新前データ保持用

    this.handleRegsiterDiary = this.handleRegsiterDiary.bind(this); // 巡回記録登録
    this.handleUpdateDiary = this.handleUpdateDiary.bind(this); // 巡回記録更新
    this.handleWithdrawDiary = this.handleWithdrawDiary.bind(this); // 取り下げ承認
    this.handleWithdrawDiaryConfirm = this.handleWithdrawDiaryConfirm.bind(
      this
    ); // 取り下げ承認
    this.handleWithdrawDiaryNeedUpdateConfirm = this.handleWithdrawDiaryNeedUpdateConfirm.bind(
      this
    );
    this.handleDeleteDiary = this.handleDeleteDiary.bind(this); // 巡回記録削除
    this.handleSelectSafetyDiary = this.handleSelectSafetyDiary.bind(this); // 巡回記録移動
    this.validate = this.validate.bind(this);
    this.handleVisibleDialog = this.handleVisibleDialog.bind(this); // ダイアログ開閉設定
    this.onLoaded = this.onLoaded.bind(this);
    this.movePageFunc = null;
  }

  componentDidMount = () => {
    this.getFieldItemFlag();
    this.getExternalServiceCooperationStatus();
    if (this.state.fieldId && !_.isNull(this.state.dataId)) {
      this.getSafetyDiary();
    } else {
      this.setState({
        loaded: true,
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.dataId && prevState.dataId !== this.state.dataId) {
      if (this.state.fieldId && !_.isNull(this.state.dataId)) {
        this.getSafetyDiary();
      }

      this.setState({ dataId: this.props.view.state.dataId });
    }

    if (
      this.props.view.state.dataId &&
      prevProps.view.state.dataId !== this.props.view.state.dataId
    ) {
      this.setState({ dataId: this.props.view.state.dataId });
    }

    if (
      !_.isEqual(prevState.validateMessages, this.state.validateMessages) ||
      !_.isEqual(prevState.formData, this.state.formData)
    ) {
      this.updateErrorState();
    }
  };

  /**
   * @description 作業場所フラグ情報取得
   */
  getFieldItemFlag() {
    FieldService.fieldItem(this.state.fieldId).then(response => {
      if (response.result === true) {
        const displayFlg = _.cloneDeep(this.state.displayFlg);
        const field_item = response.data.entities.field_item;
        _.each(displayFlg, (value, key) => {
          displayFlg[key] = field_item[key];
        });
        this.setState({ displayFlg });
      }
    });
  }

  /**
   * @description 巡回記録情報取得
   */
  getSafetyDiary() {
    const params = this.props.view.state.params || {
      date_type: SafetyDiariesConstants.dataType.entriesDate,
    };
    SafetyDiaryService.getDiary(this.state.fieldId, this.state.dataId, params)
      .then(response => {
        // 詳細画面を表示すべきなのに編集画面を表示された場合は、詳細画面へ遷移する。
        // 直リンクで直接遷移した時に上記の可能性がある。
        if (
          SafetyDiariesConstants.pageName.safetyDiariesConfirm ===
          getSafetyDiaryDetailPageName(response.data.entities.safety_diary)
        ) {
          this.handleSelectSafetyDiary(response.data.entities.safety_diary);
        } else {
          this.setState({
            canEdit: canSafetyDiaryEdit(response.data.entities.safety_diary),
            canRemove: canSafetyDiaryRemove(
              response.data.entities.safety_diary
            ),
            next: response.data.entities.prev,
            prev: response.data.entities.next,
            loaded: true,
          });
        }
      })
      .catch(error => {
        const errorMessage = error.toString();
        if (errorMessage.includes('Network Error')) {
          console.error(
            'request.js requestWithToken',
            'ネットワークエラーです',
            errorMessage
          );
          this.handleCloseSlide();
        }
        switch (error.status) {
          // force logout, if authorization failed.
          case 400: {
            this.handleCloseSlide();
            return false;
          }
          case 401: {
            // エラーメッセージをダイアログに出力後、ログアウト処理を実行
            dialogLoader.show(
              CcusErrorDialog,
              {
                callback: {
                  done: () => {
                    AuthProvider.instance.logout();
                  },
                },
                message:
                  error.data.message || messageUtility.getMessage('E-000-036'),
              },
              null
            );
            return false;
          }
          case 403: {
            this.handleCloseSlide();
            return false;
          }
          case 404: {
            this.handleVisibleDialog(DIALOG_NAME.notFound);
            Loader.done();
            return false;
          }
          case 422: {
            this.handleCloseSlide();
            return false;
          }
          case 500: {
            console.error(
              'request.js requestWithToken',
              'ネットワークエラー 500 です',
              JSON.stringify(error)
            );
            window.location.replace('/error-500');
            return false;
          }
          case 503: {
            window.location.replace('/');
            return false;
          }
          default: {
            console.error(
              'request.js requestWithToken',
              'ネットワークエラーです',
              errorMessage
            );
            window.location.replace('/error-500');
            return false;
          }
        }
      });
  }

  onLoaded = formData => {
    this.prevUpdateFormData = formData;
  };

  /**
   * @description 巡回記録登録
   */
  handleRegsiterDiary() {
    // 多重更新防止
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;

    const isSuccess = this.validate(this.state.formData, true);
    if (!isSuccess) {
      this.updatingFlag = false;
      return;
    }
    const formData = _.cloneDeep(this.state.formData);
    if (
      Number(formData.send_external_service_cooperation) ===
      FLAG_STAUS.negative.id
    ) {
      formData.lw_talkroom_ids = [];
      formData.direct_talkroom_ids = [];
    }
    const postData = {
      data: [
        {
          ...formData,
          create_user_id: this.state.userId,
          content_update_user_id: this.state.userId,
          field_id: this.state.fieldId,
        },
      ],
    };
    SafetyDiaryService.register(this.state.fieldId, postData).then(response => {
      if (response.result === true) {
        const notNotifiedUsers = _.get(
          response,
          'data.entities.not_notified_users'
        );
        if (_.size(notNotifiedUsers) > 0) {
          this.setState({ notNotifiedUsers });
          this.movePageFunc = this.handleCloseSlide;
          this.handleVisibleDialog(DIALOG_NAME.notNotifiedUsers);
        } else {
          this.handleVisibleDialog(null);
          this.handleCloseSlide();
        }
      } else {
        const targetMsg =
          '多重送信を検知したため、2回目以降の処理を止めました。登録内容が反映されているかご確認ください。';
        if (
          response.status === 400 &&
          response.data.message.includes(targetMsg)
        ) {
          this.showErrorDialog(response.data.message, '多重送信を検知しました');
        }
      }
    }).finally(() => {
      this.updatingFlag = false;
    });
  }

  updateDiary = async () => {
    const isSuccess = this.validate(this.state.formData, true);
    if (!isSuccess) {
      this.updatingFlag = false;
      return;
    }

    let endDate = _.cloneDeep(this.state.formData.end_date);
    if (!_.isNull(endDate)) {
      endDate = Moment(this.state.formData.end_date, 'YYYY-MM-DD').format(
        'YYYYMMDD'
      );
    }

    const postData = {
      ...this.state.formData,
      end_date: endDate,
      entries_date: Moment(
        this.state.formData.entries_date,
        'YYYY-MM-DD'
      ).format('YYYYMMDD'),
      content_update_time: Moment(),
      content_update_user_id: this.state.userId,
    };
    const response = await SafetyDiaryService.update(
      this.state.fieldId,
      this.state.dataId,
      _.omit(postData, 'create_user_id')
    );
    if (response.result === true) {
      this.prevUpdateFormData = this.state.formData;
    }
    return response;
  };

  /**
   * @description 巡回記録更新
   */
  async handleUpdateDiary() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const response = await this.updateDiary();
    const isSuccess = typeof response === 'object' && response.result;

    if (isSuccess === true) {
      const notNotifiedUsers = _.get(
        response,
        'data.entities.not_notified_users'
      );
      if (_.size(notNotifiedUsers) > 0) {
        this.setState({
          notNotifiedUsers,
        });
        this.movePageFunc = this.handleCloseSlide;
        this.handleVisibleDialog(DIALOG_NAME.notNotifiedUsers);
      } else {
        this.handleVisibleDialog(null);
        this.handleCloseSlide();
      }
    }
    this.updatingFlag = false;
  }

  handleUpdateDiaryConfirm = async callbackFn => {
    if (this.updatingFlag || this.updateErrorState(true)) {
      this.handleVisibleDialog(null);
      return;
    }
    this.updatingFlag = true;
    const response = await this.updateDiary();
    const isSuccess = typeof response === 'object' && response.result;
    if (isSuccess === true) {
      const notNotifiedUsers = _.get(
        response,
        'data.entities.not_notified_users'
      );
      if (_.size(notNotifiedUsers) > 0) {
        this.setState({
          notNotifiedUsers,
        });
        this.handleVisibleDialog(DIALOG_NAME.notNotifiedUsers);
      } else {
        callbackFn && callbackFn();
        this.handleVisibleDialog(null);
      }
    }
    this.updatingFlag = false;
  };

  validateNotificationTargetOnSubmit = (
    validateMessages,
    isPointOut,
    isShowSendNotificationLw
  ) => {
    let newValidateMessage = _.cloneDeep(validateMessages);
    newValidateMessage = this.validateAllTalkRoom(
      newValidateMessage,
      isShowSendNotificationLw
    );

    if (!isPointOut) {
      delete newValidateMessage.notification_manager;
      delete newValidateMessage.notification_field_tree;
      delete newValidateMessage.notification_group;
      return newValidateMessage;
    }
    if (
      this.state.formData.notifications_manager_flag !== FLAG_STAUS.positive.id
    ) {
      delete newValidateMessage.notification_manager;
    } else {
      if (_.isEmpty(this.state.formData.notification_manager)) {
        newValidateMessage.notification_manager = localizeMessage.required;
      }
    }
    if (
      this.state.formData.notifications_company_flag !== FLAG_STAUS.positive.id
    ) {
      delete newValidateMessage.notification_field_tree;
    } else {
      if (_.isEmpty(this.state.formData.notification_field_tree)) {
        newValidateMessage.notification_field_tree = localizeMessage.required;
      }
    }
    if (
      this.state.formData.notifications_group_flag !== FLAG_STAUS.positive.id
    ) {
      delete newValidateMessage.notification_group;
    } else {
      if (_.isEmpty(this.state.formData.notification_group)) {
        newValidateMessage.notification_group = localizeMessage.required;
      }
    }
    return newValidateMessage;
  };

  /**
   * @description バリデーションチェック
   * @param {object} formValues 全入力値
   * @param {object} isSubmit true: 登録, 更新時のバリデーション false: 入力時のバリデーション
   * @param {string} name
   */
  validate(formValues, isSubmit = false, name) {
    const { reportType } = SafetyDiariesConstants;
    const {
      type,
      entries_date,
      end_date,
      send_external_service_cooperation,
    } = _.cloneDeep(formValues);
    let validateMessages = _.cloneDeep(this.state.validateMessages);

    if (
      Number(type) === reportType.wellKnown.id &&
      !Moment(entries_date, 'YYYY/MM/DD').isSameOrBefore(end_date, 'YYYY/MM/DD')
    ) {
      validateMessages.end_date = messageUtility.getMessage('E-001-311');
    } else {
      delete validateMessages.end_date;
    }
    const isPointOut = Number(type) === reportType.pointOut.id;
    const isShowSendExternalServiceCooperation =
      send_external_service_cooperation &&
      [
        reportType.pointOut.id,
        reportType.contact.id,
        reportType.wellKnown.id,
      ].includes(type);
    if (isPointOut && name) {
      if (_.isEmpty(formValues[name])) {
        validateMessages[name] = localizeMessage.required;
      } else {
        delete validateMessages[name];
      }
    }
    const { keyLwId } = SafetyDiariesConstants;
    if (isShowSendExternalServiceCooperation && _.includes(keyLwId, name)) {
      if (_.isEmpty(formValues[name])) {
        validateMessages[name] = localizeMessage.required;
      }
      if (
        !_.isEmpty(formValues.lw_talkroom_ids) ||
        !_.isEmpty(formValues.direct_talkroom_ids)
      ) {
        validateMessages = _.omit(validateMessages, [
          'lw_talkroom_ids',
          'direct_talkroom_ids',
        ]);
      }
    }
    this.setState({ validateMessages });

    if (isSubmit) {
      validateMessages = this.validateNotificationTargetOnSubmit(
        validateMessages,
        isPointOut,
        isShowSendExternalServiceCooperation
      );
      this.setState({ validateMessages });
      return _.isEmpty(validateMessages);
    }
  }

  /**
   * @description 巡回記録是正報告画面に移動
   */
  handleMovePage = callbackFn => {
    // 編集されていたら遷移前に更新するかの確認メッセージを表示する
    if (!_.isEqual(this.state.formData, this.prevUpdateFormData)) {
      this.handleVisibleDialog(DIALOG_NAME.movePage);
      this.movePageFunc = callbackFn;
    } else {
      callbackFn && callbackFn();
    }
  };

  /**
   * @description 巡回記録是正報告画面に移動
   */
  goRegisterRecovery = () => {
    const { pageName } = SafetyDiariesConstants;
    this.handleOpenNewSlide({
      name: pageName.safetyDiariesRecoveryRegister,
      state: {
        id: this.state.dataId,
        dataId: this.state.dataId,
        params: this.props.view.state.params,
      },
    });
  };

  updateWithdrawDiary = async () => {
    const postData = {
      finish_date: Moment().format('YYYYMMDD'),
      finish_flag: 1,
      approval_user_id: this.state.userId,
    };
    const response = await SafetyDiaryService.approval(
      this.state.fieldId,
      this.state.dataId,
      postData
    );
    return response.result;
  };

  /**
   * @description 取り下げ承認
   */
  handleWithdrawDiary = async () => {
    // 編集されていたら遷移前に更新するかの確認メッセージを表示する
    if (_.isEqual(this.state.formData, this.prevUpdateFormData)) {
      this.handleVisibleDialog(DIALOG_NAME.withdraw);
    } else {
      this.handleVisibleDialog(DIALOG_NAME.withdrawNeedUpdate);
    }
  };

  /**
   * @description 取り下げ承認確認ボタン押下
   */
  handleWithdrawDiaryConfirm = async () => {
    // 多重更新防止
    if (this.updatingFlag || this.updateErrorState(true)) {
      return;
    }
    this.updatingFlag = true;

    const isSuccess = await this.updateWithdrawDiary();
    if (isSuccess) {
      this.handleCloseSlide();
    }

    this.updatingFlag = false;
  };

  /**
   * @description 取り下げ承認確認ボタン押下(更新必要)
   */
  handleWithdrawDiaryNeedUpdateConfirm = async () => {
    // 多重更新防止
    if (this.updatingFlag || this.updateErrorState(true)) {
      this.handleVisibleDialog(null);
      return;
    }
    this.updatingFlag = true;
    const response = await this.updateDiary();
    const isSuccessWithdrawDiary = await this.updateWithdrawDiary();
    const isSuccess =
      typeof response === 'object' && response.result && isSuccessWithdrawDiary;
    if (isSuccess) {
      const notNotifiedUsers = _.get(
        response,
        'data.entities.not_notified_users'
      );
      if (_.size(notNotifiedUsers) > 0) {
        this.setState({ notNotifiedUsers });
        this.movePageFunc = this.handleCloseSlide;
        this.handleVisibleDialog(DIALOG_NAME.notNotifiedUsers);
      } else {
        this.handleVisibleDialog(null);
        this.handleCloseSlide();
      }
    }
    this.updatingFlag = false;
  };

  /**
   * @description 巡回記録削除
   */
  handleDeleteDiary = () => {
    SafetyDiaryService.deleteDiary(this.state.fieldId, this.state.dataId).then(
      response => {
        if (response.result === true) {
          this.handleCloseSlide();
        }
      }
    );
  };

  /**
   * @description 巡回記録移動
   */
  handleSelectSafetyDiary = data => {
    _slideLoader.show(
      getSafetyDiaryDetailPageName(data),
      {
        state: {
          id: data.id,
          dataId: data.id,
          params: this.props.view.state.params,
        },
      },
      this.props.vw
    );
  };

  /**
   * @description 画面クローズ
   */
  handleCloseSlide = () => {
    _slideLoader.close(this.props.vw);
  };

  /**
   * @description 画面オープン
   */
  handleOpenNewSlide = object => {
    _slideLoader.close(this.props.vw);
    _slideLoader.show(
      object.name,
      { state: { ...object.state } },
      this.props.vw
    );
  };

  /**
   * @description 是正内容ボタン制御
   */
  renderRecoveryButtons = () => {
    const { reportType } = SafetyDiariesConstants;

    return (
      <React.Fragment>
        {!_.isNull(this.state.dataId) &&
          this.state.formData.type === reportType.pointOut.id && (
            <button
              className='btn--stay'
              onClick={() => this.handleMovePage(this.goRegisterRecovery)}
            >
              是正内容を入力する
            </button>
          )}
      </React.Fragment>
    );
  };

  /**
   * @description ダイアログ開閉設定
   * @param {string} visibleDialogName ダイアログ名(DIALOG_NAME)
   *                                   ※ nullの場合は、ダイアログを閉じる
   */
  handleVisibleDialog = visibleDialogName => {
    this.setState({ visibleDialogName });
  };

  showErrorDialog = (message, title) => {
    dialogLoader.show(FormInformationDialog, {
      title,
      message,
      onClose: () => {
        dialogLoader.close();
      },
    });
  };

  closeEditView = () => {
    dialogLoader.show(CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          this.handleCloseSlide();
          dialogLoader.close();
        },
      },
    });
  };

  updateErrorState = isUpdate => {
    let validateMessages = _.cloneDeep(this.state.validateMessages);
    const { pointOut, contact, wellKnown } = SafetyDiariesConstants.reportType;
    const positiveId = FLAG_STAUS.positive.id;
    const {
      notifications_manager_flag,
      notifications_company_flag,
      notifications_group_flag,
      type,
      send_external_service_cooperation,
    } = this.state.formData;
    const isShowSendExternalServiceCooperation =
      send_external_service_cooperation &&
      [pointOut.id, contact.id, wellKnown.id].includes(type);
    if (isUpdate) {
      validateMessages = this.validateNotificationTargetOnSubmit(
        validateMessages,
        type === pointOut.id,
        isShowSendExternalServiceCooperation
      );
    }
    const notificationTargetError =
      (_.has(validateMessages, 'notification_manager') &&
        notifications_manager_flag === positiveId) ||
      (_.has(validateMessages, 'notification_field_tree') &&
        notifications_company_flag === positiveId) ||
      (_.has(validateMessages, 'notification_group') &&
        notifications_group_flag === positiveId);
    let hasError = !(
      _.isEmpty(validateMessages) ||
      (type !== pointOut.id && type !== wellKnown.id) ||
      (type === pointOut.id && !notificationTargetError) ||
      (type === wellKnown.id && !_.has(validateMessages, 'end_date'))
    );
    if (
      isShowSendExternalServiceCooperation &&
      (_.has(validateMessages, 'lw_talkroom_ids') ||
        _.has(validateMessages, 'direct_talkroom_ids'))
    ) {
      hasError = true;
    }
    this.setState({
      hasError,
    });
    if (isUpdate) {
      this.setState({
        validateMessages,
      });
    }
    return hasError;
  };
  getExternalServiceCooperationStatus = async () => {
    const { dataId } = this.state;
    if (isNullOrEmpty(dataId)) {
      const response = await ExternalServiceCooperationStatusApi.list.get({
        field_id: this.state.fieldId,
      });
      if (response.result) {
        const externalServiceCooperationStatus = _.get(
          response,
          'data.entities'
        );
        this.setState(
          {
            externalServiceCooperationStatus,
          },
          () => {
            if (_.get(externalServiceCooperationStatus, 'direct.available')) {
              this.checkDirectTalkRoom();
            }
          }
        );
      }
    }
  };
  checkDirectTalkRoom = async () => {
    let status = false;
    let directTalkRooms = [];
    const response = await FieldService.listDirectRooms({
      field_id: this.state.fieldId,
    });
    if (response.result) {
      status = true;
      directTalkRooms = _.get(response, 'data.entities.direct_talkrooms') || [];
    }
    this.setState({
      callApiDirectTalkRoomStatus: status,
      directTalkRooms,
    });
  };
  validateAllTalkRoom = (validateMessages, isShowSendNotificationLw) => {
    const { keyLwId } = safetyDiariesConstants;
    if (!isShowSendNotificationLw) {
      return _.omit(validateMessages, keyLwId);
    }
    const {
      formData: { lw_talkroom_ids, direct_talkroom_ids },
      externalServiceCooperationStatus: { line_works, direct },
    } = this.state;
    const isRequiredLw = line_works.available;
    const isRequiredDirect =
      direct.available || direct.reason_code === DIRECT_STATUS_CODE.UNAVAILABLE;
    if (isRequiredLw && isRequiredDirect) {
      if (!_.isEmpty(lw_talkroom_ids) || !_.isEmpty(direct_talkroom_ids)) {
        return _.omit(validateMessages, keyLwId);
      }
      _.forEach(keyLwId, key => {
        validateMessages[key] = localizeMessage.required;
      });
      return validateMessages;
    }
    if (isRequiredLw) {
      if (_.isEmpty(lw_talkroom_ids)) {
        validateMessages.lw_talkroom_ids = localizeMessage.required;
      } else {
        validateMessages = _.omit(validateMessages, 'lw_talkroom_ids');
      }
      return validateMessages;
    }
    if (isRequiredDirect) {
      if (_.isEmpty(direct_talkroom_ids)) {
        validateMessages.direct_talkroom_ids = localizeMessage.required;
      } else {
        validateMessages = _.omit(validateMessages, 'direct_talkroom_ids');
      }
      return validateMessages;
    }
    return validateMessages;
  };

  render() {
    const { reportType } = SafetyDiariesConstants;
    const {
      loaded,
      dataId,
      canEdit,
      canRemove,
      prev,
      next,
      hasError,
    } = this.state;
    return (
      <div className='slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} -
            {!_.isNull(dataId) ? ` 巡回記録編集` : ` 巡回記録新規作成`}
          </title>
        </Helmet>
        <div className='slide-view__view'>
          <ConferencePageHeader
            dataTestId={
              !_.isNull(dataId)
                ? `safety-diaries-edit`
                : `safety-diaries-register`
            }
            loaded={loaded}
            title={!_.isNull(dataId) ? '巡回記録編集' : '巡回記録新規作成'}
            leftComponent={
              <React.Fragment>
                {_.isNull(dataId) ? (
                  <button
                    className={hasError ? 'btn--disabled' : 'btn--effective'}
                    onClick={this.handleRegsiterDiary}
                  >
                    登録
                  </button>
                ) : canEdit ? (
                  <button
                    className='btn--effective'
                    onClick={this.handleUpdateDiary}
                  >
                    更新
                  </button>
                ) : null}
                {!_.isNull(dataId) && canRemove && (
                  <button
                    className='btn--negative'
                    onClick={() => this.handleVisibleDialog(DIALOG_NAME.delete)}
                  >
                    削除
                  </button>
                )}
                {!_.isNull(dataId) &&
                  this.state.formData.type === reportType.pointOut.id &&
                  canEdit && (
                    <button
                      className='btn--sub'
                      onClick={this.handleWithdrawDiary}
                    >
                      取り下げ承認
                    </button>
                  )}
                {this.renderRecoveryButtons()}
              </React.Fragment>
            }
            loaderComponent={
              <div className='slide-view__title'>
                <ClipLoader size={20} color={'#EDB715'} />
              </div>
            }
            rightComponent={
              <div className='slide-view__header-end-item'>
                <div className='form-list__header-alert show'>
                  {!hasError ? '' : '入力エラーがあります。'}
                </div>
              </div>
            }
            onClose={this.closeEditView}
          />
          <div className='slide-view__body SafetyDiaries'>
            {(prev || next) && (
              <div className='SafetyDiaries__paging'>
                {prev && (
                  <button
                    className='SafetyDiaries__paging--prev'
                    onClick={() => {
                      this.handleMovePage(() => {
                        this.handleSelectSafetyDiary(prev);
                      });
                    }}
                  >
                    <ArrowPagingIcon className='SafetyDiaries__paging-arrow icon--2x' />
                    <span className='SafetyDiaries__paging-text'>前へ</span>
                  </button>
                )}
                {prev && next && (
                  <span className='SafetyDiaries__paging-segment' />
                )}
                {next && (
                  <button
                    className='SafetyDiaries__paging--next'
                    onClick={() => {
                      this.handleMovePage(() => {
                        this.handleSelectSafetyDiary(next);
                      });
                    }}
                  >
                    <span className='SafetyDiaries__paging-text'>次へ</span>
                    <ArrowPagingIcon className='SafetyDiaries__paging-arrow icon--2x' />
                  </button>
                )}
              </div>
            )}
            <SafetyDiaryForm
              value={this.state.displayFlg}
              history={this.props.history}
              dataId={dataId}
              params={this.props.view.state.params}
              onUpdate={formData => {
                this.setState({ formData });
              }}
              onLoaded={this.onLoaded}
              onValidate={this.validate}
              setValidateMessages={validateMessages =>
                this.setState({ validateMessages })
              }
              onVisibleDialog={this.handleVisibleDialog}
              errors={this.state.validateMessages}
              isEdit={!isNullOrEmpty(dataId)}
              loaded={loaded}
              isSpace={!(next || prev)}
              externalServiceCooperationStatus={
                this.state.externalServiceCooperationStatus
              }
              callApiDirectTalkRoomStatus={
                this.state.callApiDirectTalkRoomStatus
              }
              directTalkRooms={this.state.directTalkRooms}
            />
          </div>
        </div>

        <Confirmation
          visible={this.state.visibleDialogName === DIALOG_NAME.withdraw}
          title={'指摘事項の取り下げ承認'}
          message={messageUtility.getMessage('I-001-412')}
          confirmButtonText={'取り下げ承認'}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.handleWithdrawDiaryConfirm}
          onCancel={() => this.handleVisibleDialog(null)}
        />
        <Confirmation
          rootClassName='SafetyDiaries__confirm-modal'
          visible={
            this.state.visibleDialogName === DIALOG_NAME.withdrawNeedUpdate
          }
          title='指摘事項の取下げ承認'
          message={
            <React.Fragment>
              <div>指摘事項が変更されています。</div>
              <div>
                変更を保存した上で取下げ承認を行いますが、よろしいですか？
              </div>
              <div>
                取下げ承認を行うと、是正内容を入力せずに承認済の状態になります。
              </div>
            </React.Fragment>
          }
          confirmButtonText='保存して取下げ承認'
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={async () => {
            await this.handleWithdrawDiaryNeedUpdateConfirm();
          }}
          onCancel={() => this.handleVisibleDialog(null)}
        />
        <Confirmation
          visible={this.state.visibleDialogName === DIALOG_NAME.delete}
          title='巡回記録/各種連絡の削除'
          message={messageUtility.getMessage('I-001-321')}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.handleDeleteDiary}
          onCancel={() => this.handleVisibleDialog(null)}
        />
        <Confirmation
          title='変更内容の保存'
          visible={this.state.visibleDialogName === DIALOG_NAME.movePage}
          message={
            <React.Fragment>
              <div>現在開いているページの内容が変更されています。</div>
              <div>ページを移動する前に、変更を保存してよろしいですか？</div>
            </React.Fragment>
          }
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          confirmButtonText='保存して移動'
          onConfirm={async () => {
            await this.handleUpdateDiaryConfirm(this.movePageFunc);
          }}
          onCancel={() => this.handleVisibleDialog(null)}
        />
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.errorfileType}
          title='対応していない画像形式です'
          message={messageUtility.getMessage('E-000-012')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog(null)}
          multilineText={true}
        />
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.errorfileSize}
          title='ファイルサイズが大きすぎます'
          message={messageUtility.getMessage('E-001-314')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog(null)}
          multilineText={true}
        />
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.notFound}
          title=''
          message={messageUtility.getMessage('E-001-431')}
          buttonText={messageUtility.getMessage('E-001-432')}
          onClose={() => this.handleCloseSlide()}
        />
        <Information
          rootClassName='SafetyDiaries__not-notified-user-modal'
          title='通知対象の確認'
          visible={
            this.state.visibleDialogName === DIALOG_NAME.notNotifiedUsers
          }
          message={
            <React.Fragment>
              {messageUtility.getMessage('I-001-421')}
              <br />
              <br />
              <div>
                <table>
                  {_.map(this.state.notNotifiedUsers, user => {
                    return (
                      <tr>
                        <td>{user.company_name}</td>
                        <td>：</td>
                        <td>{user.user_name}</td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            </React.Fragment>
          }
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => {
            if (_.isFunction(this.movePageFunc)) {
              this.movePageFunc();
            }
            this.handleVisibleDialog(null);
          }}
          multilineText={true}
        />
      </div>
    );
  }
}
export default withRouter(SafetyDiariesRegister);



// WEBPACK FOOTER //
// ./src/pages/SafetyDiariesRegister.jsx